export interface Quote {
  text: string;
  author: string;
}

export const QUOTES: Quote[] = [
  { text: "Whether you think you can or you think you can't, you're right.", author: "Henry Ford" },
  { text: "Ideas are easy. Implementation is hard.", author: "Guy Kawasaki" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "Done is better than perfect.", author: "Sheryl Sandberg" },
  { text: "Move fast, but stay patient with the results.", author: "Unknown" },
  { text: "Success is the sum of small efforts repeated day in and day out.", author: "Robert Collier" },
  { text: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe" },
  { text: "Chase the vision, not the money; the money ends up following you.", author: "Tony Hsieh" },
  { text: "You don't have to be great to start, but you have to start to be great.", author: "Zig Ziglar" },
  { text: "A goal without a plan is just a wish.", author: "Antoine de Saint-Exupéry" },
  { text: "Opportunities don't happen. You create them.", author: "Chris Grosser" },
  { text: "Make something people want.", author: "Paul Graham" },
  { text: "Amateurs wait for inspiration. The rest of us just get up and go to work.", author: "Chuck Close" },
  { text: "Every day you're not building, someone else is.", author: "Unknown" },
  { text: "Small daily improvements are the key to staggering long-term results.", author: "Unknown" },
  { text: "Fall in love with the problem, not the solution.", author: "Uri Levine" },
];

export function pickQuote(): Quote {
  return QUOTES[Math.floor(Math.random() * QUOTES.length)]!;
}
